export const categories = [
  {
    slug: "star",
    name: "星闻速递",
    desc: "剧组动态与圈内新鲜事",
    icon: "ri-star-smile-line",
  },
  {
    slug: "drama",
    name: "剧集热评",
    desc: "热播剧集深度讨论",
    icon: "ri-movie-2-line",
  },
  {
    slug: "variety",
    name: "综艺高能",
    desc: "综艺名场面与幕后花絮",
    icon: "ri-live-line",
  },
  {
    slug: "stage",
    name: "舞台现场",
    desc: "巡演与音乐现场速递",
    icon: "ri-mic-line",
  },
  {
    slug: "style",
    name: "红毯穿搭",
    desc: "红毯造型与穿搭解析",
    icon: "ri-vip-diamond-line",
  },
  {
    slug: "buzz",
    name: "网络热议",
    desc: "全网话题与网友观点",
    icon: "ri-fire-line",
  },
];